// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from 'react';
import { Loading } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { SquareArrowOutUpRight } from 'lucide-react';

import ProductPropType from 'Types/product';
import IFrameComponent from 'Components/IFrame/IFrame';
import { API_IQUOTE } from 'Constants';

const IQuote = props => {
  const { product = {} } = props;
  const [response, setResponse] = useState();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleIQuote = async () => {
    setLoading(true);
    try {
      const getUrl = await fetch(`${API_IQUOTE}?productCode=${product.code}&ref=${encodeURIComponent(window.location)}`);
      const resp = await getUrl.json();
      setResponse(resp);
    } catch {
      setResponse('Request error!');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (response) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }, [response]);

  return (
    <>
      {
        product.inIquote && (
          <button
            type="button"
            className="iQuote"
            onClick={ handleIQuote }
            kind="ghost"
            data-test="inIquoteView"
            data-testid={ product.inIquote }
          >
            { loading && <Loading active small withOverlay={ false } /> }
            <SquareArrowOutUpRight />{ t('products.iQuote') }
          </button>
        )
      }
      {
        response && (
          <IFrameComponent source={ response } onBackButtonClick={ () => setResponse() } />
        )
      }
    </>
  );
};

IQuote.propTypes = {
  product: ProductPropType,
};

export default IQuote;
